import Dialog from '@/components/layout/ModalDialog';

export default {
  install(Vue, options = {}, vuetify) {
    const defaultProps = { ...options };
    const ComponentClass = Vue.extend(Dialog);

    const obj = {
      open(props) {
        const propsData = { defaultProps, ...props };
        const instance = new ComponentClass({
          propsData,
          vuetify
        });
        instance.$mount();
        instance.open();
        return instance;
      }
    };
    Object.defineProperty(Vue.prototype, '$dialog', { value: obj });
  },
};
